var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"shareBox"},_vm._l((_vm.items),function(item){return _c('li',{key:item.id,staticClass:"item",on:{"click":function($event){return _vm.doSomething(item)}}},[_c('i',{staticClass:"base-iconfont",class:item.icon})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }